import { CHICLET_LIST, SPINNER, TEXT_LIST } from 'crm-cards-sdk/constants/LoadingComponentProps';
import adobeSignCrmCardTranslations from 'i2l?mode=very-lazy&query=sporks!adobe-sign-cards-lib/lang/en.lyaml';
import workflowsInvokerCardTranslations from 'i2l?mode=very-lazy&query=sporks!automation-ui-crm-card-workflows-invoker/lang/en.lyaml';
import buyerIntentTranslations from 'i2l?mode=very-lazy&query=sporks!buyer-intent-card/lang/en.lyaml';
import associatedObjectsCardSdkCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-associated-objects-lib/lang/en.lyaml';
import callSummaryCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-call-summaries-lib/lang/en.lyaml';
import customEventCardTranslations from 'i2l?mode=very-lazy&query=sporks!custom-events-card-lib/lang/en.lyaml';
import companySummaryCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-company-summary-lib/lang/en.lyaml';
import customerSpendTrendsCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-customer-spend-trends-lib/lang/en.lyaml';
import attachmentsCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-engagement-attachments-lib/lang/en.lyaml';
import flywheelCompanyOverviewCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-flywheel-company-overview-lib/lang/en.lyaml';
import flywheelHighIntentAssociatedContactsCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-flywheel-high-intent-associated-contacts-lib/lang/en.lyaml';
import knowledgeBaseCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-knowledge-base-lib/lang/en.lyaml';
import leadInsightsCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-lead-insights/lang/en.lyaml';
import leadQualificationCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-lead-qualification-lib/lang/en.lyaml';
import aiDynamicCardTranslations from 'i2l?mode=very-lazy&query=sporks!ai-dynamic-card/lang/en.lyaml';
import aiObjectSummaryCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-object-summary-lib/lang/en.lyaml';
import otherTicketsCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-other-tickets-lib/lang/en.lyaml';
import objectHighlightCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-object-highlight-lib/lang/en.lyaml';
import portalUsageOutcomesCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-partner-client-portal-usage-outcomes-lib/lang/en.lyaml';
import unifiedUsageScoreCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-partner-client-unified-usage-score-lib/lang/en.lyaml';
import aboutThisRecordCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-properties-lib/lang/en.lyaml';
import tasksTimelineCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-tasks-timeline-lib/lang/en.lyaml';
import ticketSummaryCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-ticket-summary-lib/lang/en.lyaml';
import subscriptionSidebarCardTranslations from 'i2l?mode=very-lazy&query=sporks!commerce-subscription-cards-lib/lang/en.lyaml';
import contractCardTranslations from 'i2l?mode=very-lazy&query=sporks!commerce-contract-lib/lang/en.lyaml';
import billingScheduleCardTranslations from 'i2l?mode=very-lazy&query=sporks!commerce-billing-engine-lib/lang/en.lyaml';
import commercePaymentDisputeCardTranslations from 'i2l?mode=very-lazy&query=sporks!commerce-payment-dispute-card/lang/en.lyaml';
import crmActionsTranslations from 'i2l?mode=very-lazy&query=sporks!crm-actions/lang/en.lyaml';
import crmAssociationPivotTranslations from 'i2l?mode=very-lazy&query=sporks!crm-associations-pivot/lang/en.lyaml';
import crmAssociationTableTranslations from 'i2l?mode=very-lazy&query=sporks!crm-associations-table/lang/en.lyaml';
import crmDataHighlightsTranslations from 'i2l?mode=very-lazy&query=sporks!crm-data-highlights/lang/en.lyaml';
import crmActivitiesV2CardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-events-viz-cards/lang/crmActivitiesV2Card/en.lyaml';
import crmAllboundTimelineCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-events-viz-cards/lang/crmAllboundTimelineCard/en.lyaml';
import crmEventsVizTimelineCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-events-viz-cards/lang/crmEventsVizTimelineCard/en.lyaml';
import crmRecordTimelineCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-events-viz-cards/lang/crmRecordTimelineCard/en.lyaml';
import activityTotalsCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-events-viz-totals/lang/en.lyaml';
import crmExtensionTranslations from 'i2l?mode=very-lazy&query=sporks!crm-extension/lang/en.lyaml';
import pipelineApprovalsCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-pipeline-approvals-lib/lang/en.lyaml';
import crmPropertiesListTranslations from 'i2l?mode=very-lazy&query=sporks!crm-properties-list/lang/en.lyaml';
import crmPropertyHistoryTranslations from 'i2l?mode=very-lazy&query=sporks!crm-property-history/lang/en.lyaml';
import crmRelativeTimelineTranslations from 'i2l?mode=very-lazy&query=sporks!crm-relative-timeline/lang/en.lyaml';
import crmReportCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-report/lang/en.lyaml';
import crmSimpleDeadlineTranslations from 'i2l?mode=very-lazy&query=sporks!crm-simple-deadline/lang/en.lyaml';
import crmStageTrackerTranslations from 'i2l?mode=very-lazy&query=sporks!crm-stage-tracker/lang/en.lyaml';
import crmStatisticsTranslations from 'i2l?mode=very-lazy&query=sporks!crm-statistics/lang/en.lyaml';
import shopifyOverviewCardTranslations from 'i2l?mode=very-lazy&query=sporks!customer-overview-card-lib/lang/en.lyaml';
import customerSuccessContactsCardTranslations from 'i2l?mode=very-lazy&query=sporks!customer-success-contacts-card-lib/lang/en.lyaml';
import guidedSellingDealSummaryTranslations from 'i2l?mode=very-lazy&query=sporks!deal-summary-components/lang/en.lyaml';
import docusignCrmCardTranslations from 'i2l?mode=very-lazy&query=sporks!docusign-cards-lib/lang/en.lyaml';
import googleDriveAttachmentsCardTranslations from 'i2l?mode=very-lazy&query=sporks!ui-google-drive-attachments/lang/en.lyaml';
import googleDriveInsightsCardTranslations from 'i2l?mode=very-lazy&query=sporks!ui-google-drive-insights/lang/en.lyaml';
import guidedActionsCardTranslations from 'i2l?mode=very-lazy&query=sporks!guided-actions-card/lang/en.lyaml';
import guidedExecutionActivitiesCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-guided-execution-activities/lang/en.lyaml';
import healthScoreCardTranslations from 'i2l?mode=very-lazy&query=sporks!health-score-card-lib/lang/en.lyaml';
import intelligenceOverviewTranslations from 'i2l?mode=very-lazy&query=sporks!intelligence-overview-lib/lang/en.lyaml';
import invoicesHistoryCardTranslations from 'i2l?mode=very-lazy&query=sporks!invoices-history-card-lib/lang/en.lyaml';
import leadScoresCardTranslations from 'i2l?mode=very-lazy&query=sporks!lead-scores-card/lang/en.lyaml';
import legacySidebarCardTranslations from 'i2l?mode=very-lazy&query=sporks!legacy-sidebar-card-lib/lang/en.lyaml';
import marketingEventAttendanceCardTranslations from 'i2l?mode=very-lazy&query=sporks!marketing-event-attendance-cards-ui/lang/en.lyaml';
import paymentScheduleCardTranslations from 'i2l?mode=very-lazy&query=sporks!payment-schedule-card-lib/lang/en.lyaml';
import advancedPlaybooksCardTranslations from 'i2l?mode=very-lazy&query=sporks!playbooks-card/lang/en.lyaml';
import scoreSummaryCardTranslations from 'i2l?mode=very-lazy&query=sporks!predictive-scores-card/lang/en.lyaml';
import processGuideCardTranslations from 'i2l?mode=very-lazy&query=sporks!process-guide-cards/lang/en.lyaml';
import partnerAiSummaryCardTranslations from 'i2l?mode=very-lazy&query=sporks!partner-ai-summary-crm-card/lang/en.lyaml';
import productPricingInfoCardTranslations from 'i2l?mode=very-lazy&query=sporks!products-cards-lib/lang/en.lyaml';
import productBundleAboutCardTranslations from 'i2l?mode=very-lazy&query=sporks!bundle-about-card/lang/en.lyaml';
import productBundleItemsCardTranslations from 'i2l?mode=very-lazy&query=sporks!bundle-items-card/lang/en.lyaml';
import { dataResolver as productBundleAboutCardDataResolver } from 'bundle-about-card/dataResolver';
import { dataResolver as productBundleItemsCardDataResolver } from 'bundle-items-card/dataResolver';
import { dataResolver as partnerAiSummaryCardDataResolver } from 'partner-ai-summary-crm-card/dataResolver';
import purchaseHistoryCardsTranslations from 'i2l?mode=very-lazy&query=sporks!purchase-history-lib/lang/en.lyaml';
import guidedSellingStageTrackerCardTranslations from 'i2l?mode=very-lazy&query=sporks!guided-selling-stage-tracker-card/lang/en.lyaml';
import guestAccessManagementCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-guest-access-management-lib/lang/en.lyaml';
import flywheelGrowthPlansCardTranslations from 'i2l?mode=very-lazy&query=sporks!flywheel-growth-plans-crm-card/lang/en.lyaml';
import prospectingResearchAgentCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-prospecting-research-agent/lang/en.lyaml';
import targetAccountSignalsCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-target-account-signals/lang/en.lyaml';
import LegacySidebarCard from 'legacy-sidebar-card-lib/LegacySidebarCard';
import { getLoadingComponentProps as getLoadingComponentPropsForLegacySidebarCard } from 'legacy-sidebar-card-lib/getLoadingComponentProps';
import { fetchAssociatedObjectsCardData } from 'card-associated-objects-lib/helpers/fetchAssociatedObjectsCardData';
import { dataResolver as flywheelActivityHistoryDataResolver } from 'card-flywheel-activity-history-lib/dataResolver';
import { dataResolver as flywheelDomainReviewHistoryDataResolver } from 'card-flywheel-domain-review-history-lib/dataResolver';
import { dataResolver as flywheelGrowthPlansDataResolver } from 'flywheel-growth-plans-crm-card/dataResolver';
import { dataResolver as commercePaymentDisputeDataResolver } from 'commerce-payment-dispute-card/dataResolver';
import { fetchAttachmentsCardData } from 'card-engagement-attachments-lib/utils/fetchAttachmentsCardData';
import clvReportCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-clv-report/lang/en.lyaml';
import crmAttributionReportTranslations from 'i2l?mode=very-lazy&query=sporks!crm-attribution-report/lang/en.lyaml';
import activityHistoryCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-flywheel-activity-history-lib/lang/en.lyaml';
import domainReviewHistoryCardTranslations from 'i2l?mode=very-lazy&query=sporks!card-flywheel-domain-review-history-lib/lang/en.lyaml';
import catchupCardTranslations from 'i2l?mode=lazy!ai-catchup-cards-lib/lang/en.lyaml';
import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import csatCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-csat/lang/en.lyaml';
import npsCardTranslations from 'i2l?mode=very-lazy&query=sporks!crm-nps/lang/en.lyaml';
import buyingGroupCardTranslations from 'i2l?mode=very-lazy&query=sporks!buying-group-card/lang/en.lyaml';
import { getLoadingComponentProps as getLoadingComponentPropsForAssociationV3 } from 'card-associated-objects-lib/localStorage/skeletonState/getLoadingComponentProps';
import { dataResolver as buyingGroupCardDataResolver } from 'buying-group-card/dataResolver';
import prospectingAgentCardTranslations from 'i2l?mode=very-lazy&query=sporks!prospecting-agent-crm-card/lang/en.lyaml';
import { dataResolver as prospectingAgentCardDataResolver } from 'prospecting-agent-crm-card/dataResolver';
const EVENTS_VIZ_TIMELINE_ENTRY_HEIGHT = 150;
export const CRM_CARDS_GLOBAL_REGISTRY_MAP = {
  ACTIVITIES: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmRecentActivitiesCard" */'crm-events-viz-cards/crmRecentActivitiesCard/CrmRecentActivitiesCard'),
    lazyLoadedTranslations: crmEventsVizTimelineCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: EVENTS_VIZ_TIMELINE_ENTRY_HEIGHT + 50
    }]
  },
  ACTIVITIES_V2: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmActivitiesV2Card" */'crm-events-viz-cards/crmActivitiesV2Card/CrmActivitiesV2Card'),
    lazyLoadedTranslations: crmActivitiesV2CardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: EVENTS_VIZ_TIMELINE_ENTRY_HEIGHT + 50
    }]
  },
  ACTIVITY_TOTALS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmEventsVizTotalsCard" */'crm-events-viz-totals/CrmEventsVizTotalsCard'),
    lazyLoadedTranslations: activityTotalsCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 100
    }]
  },
  AI_DYNAMIC_CARD: {
    cardComponentLoader: () => import( /* webpackChunkName: "AiDynamicCard" */'ai-dynamic-card/AiDynamicCard'),
    lazyLoadedTranslations: aiDynamicCardTranslations
  },
  AI_OBJECT_SUMMARY: {
    cardComponentLoader: () => import( /* webpackChunkName: "AIObjectSummaryCard" */'card-object-summary-lib/components/AIObjectSummaryCard'),
    lazyLoadedTranslations: aiObjectSummaryCardTranslations
  },
  ASSOCIATION_PIVOT: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmAssociationsPivotCard" */'crm-associations-pivot/CrmAssociationsPivotCard'),
    lazyLoadedTranslations: crmAssociationPivotTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 240
    }] // CrmAssociationsPivotCard has a custom skeleton state, match its height
  },
  ASSOCIATION_PROPERTIES_LIST: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmAssociationPropertyListCard" */'crm-properties-list/CrmAssociationPropertyListCard'),
    lazyLoadedTranslations: crmPropertiesListTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight:
        // Propeties List card uses up to 4 columns
        Math.ceil(cardData.configuration.propertyNames.length / 4) * 50
      }];
    }
  },
  ASSOCIATION_STAGE_TRACKER: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmAssociationStageTrackerCard" */'crm-stage-tracker/CrmAssociationStageTrackerCard'),
    lazyLoadedTranslations: crmStageTrackerTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight: cardData.configuration.showProperties ? 140 : 85
      }];
    }
  },
  ADVANCED_PLAYBOOKS: {
    cardComponentLoader: () => import( /* webpackChunkName: "AdvancedPlaybooksCard" */'playbooks-card/AdvancedPlaybooksCard'),
    lazyLoadedTranslations: advancedPlaybooksCardTranslations
  },
  ASSOCIATION_TABLE: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmAssociationsTableCard" */'crm-associations-table/CrmAssociationsTableCard'),
    lazyLoadedTranslations: crmAssociationTableTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 120
    }]
  },
  ASSOCIATION_V3: {
    cardComponentLoader: () => {
      const isUngatedForAssociationCardRedesign = userInfoSync().gates.includes(gate('CRM:Record:AssociationCardRedesign'));
      return isUngatedForAssociationCardRedesign ? import( /* webpackChunkName: "AssociatedObjectsCardRedesignV3" */'card-associated-objects-lib/AssociatedObjectsCard') : import( /* webpackChunkName: "AssociatedObjectsCardV3" */'card-associated-objects-lib/sdk');
    },
    lazyLoadedTranslations: associatedObjectsCardSdkCardTranslations,
    getLoadingComponentProps: getLoadingComponentPropsForAssociationV3,
    dataResolver: fetchAssociatedObjectsCardData
  },
  ATTACHMENTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "EngagementAttachmentsCard" */'card-engagement-attachments-lib/EngagementAttachmentsCardSdk'),
    lazyLoadedTranslations: attachmentsCardTranslations,
    getLoadingComponentProps: () => {
      return [{
        type: CHICLET_LIST,
        numberOfSkeletons: 1,
        numberOfProperties: 1
      }];
    },
    dataResolver: fetchAttachmentsCardData
  },
  BUYER_INTENT: {
    cardComponentLoader: () => import( /* webpackChunkName: "BuyerIntentCard" */'buyer-intent-card'),
    lazyLoadedTranslations: buyerIntentTranslations
  },
  CALL_SUMMARIES: {
    cardComponentLoader: () => import( /* webpackChunkName: "CallSummariesCard" */'card-call-summaries-lib/CallSummariesCard'),
    lazyLoadedTranslations: callSummaryCardTranslations
  },
  COMPANY_SUMMARY: {
    cardComponentLoader: () => import( /* webpackChunkName: "CompanySummaryCard" */'card-company-summary-lib/CompanySummaryCard'),
    lazyLoadedTranslations: companySummaryCardTranslations
  },
  COMPANY_DESCRIPTION: {
    cardComponentLoader: () => import( /* webpackChunkName: "CompanyDescriptionCard" */'ai-catchup-cards-lib/company-description/CompanyDescriptionCard'),
    lazyLoadedTranslations: catchupCardTranslations
  },
  CRM_EVENTS_VIZ_TIMELINE: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmEventsVizTimelineCard" */'crm-events-viz-cards/crmEventsVizTimelineCard/CrmEventsVizTimelineCard').then(mod => mod.CrmEventsVizTimelineCard),
    lazyLoadedTranslations: crmEventsVizTimelineCardTranslations
  },
  ALLBOUND_TIMELINE: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmAllboundTimelineCard" */'crm-events-viz-cards/crmAllboundTimelineCard/CrmAllboundTimelineCard').then(mod => mod.CrmAllboundTimelineCard),
    lazyLoadedTranslations: crmAllboundTimelineCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 225
    }]
  },
  CRM_REPORT: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmReportCard" */'crm-report/CrmReportCard'),
    lazyLoadedTranslations: crmReportCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 50
    }]
  },
  CUSTOMER_SPEND_TRENDS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CustomerSpendTrendsCard" */'card-customer-spend-trends-lib/CustomerSpendTrendsCard'),
    lazyLoadedTranslations: customerSpendTrendsCardTranslations
  },
  CUSTOMER_SUCCESS_CONTACTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CustomerSuccessContactsCard" */'customer-success-contacts-card-lib/CustomerSuccessContactsCard'),
    lazyLoadedTranslations: customerSuccessContactsCardTranslations
  },
  CUSTOMER_SUCCESS_HEALTH_SCORE: {
    cardComponentLoader: () => import( /* webpackChunkName: "HealthScoreCard" */'health-score-card-lib/HealthScoreCard'),
    lazyLoadedTranslations: healthScoreCardTranslations
  },
  DATA_HIGHLIGHTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmDataHighlightsCard" */'crm-data-highlights/CrmDataHighlightsCard'),
    lazyLoadedTranslations: crmDataHighlightsTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 43
    }] // Height of one row of data highlights
  },
  DEAL_SCORE_SUMMARY: {
    cardComponentLoader: () => import( /* webpackChunkName: "ScoreSummaryCard" */'predictive-scores-card/ScoreSummaryCard'),
    lazyLoadedTranslations: scoreSummaryCardTranslations
  },
  DEAL_SCORE_WITHOUT_HISTORY: {
    cardComponentLoader: () => import( /* webpackChunkName: "ScoreWithoutHistoryCard" */'predictive-scores-card/ScoreWithoutHistoryCard'),
    lazyLoadedTranslations: scoreSummaryCardTranslations
  },
  DEAL_SCORE_SUMMARY_PREVIEW: {
    cardComponentLoader: () => import( /* webpackChunkName: "ScoreSummaryPreviewCard" */'predictive-scores-card/ScoreSummaryPreviewCard'),
    lazyLoadedTranslations: scoreSummaryCardTranslations
  },
  ADOBE_SIGN: {
    cardComponentLoader: async () => {
      const {
        AdobeSignCrmCard
      } = await import( /* webpackChunkName: "AdobeSignCrmCard" */'adobe-sign-cards-lib');
      return AdobeSignCrmCard;
    },
    lazyLoadedTranslations: adobeSignCrmCardTranslations
  },
  DOCUSIGN_V2: {
    cardComponentLoader: async () => {
      const {
        DocusignCrmCard
      } = await import( /* webpackChunkName: "docusign" */'docusign-cards-lib');
      return DocusignCrmCard;
    },
    lazyLoadedTranslations: docusignCrmCardTranslations
  },
  EXTENSION: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmExtensionCard" */'crm-extension/CrmExtensionCard'),
    lazyLoadedTranslations: crmExtensionTranslations
  },
  FLYWHEEL_ACTIVITY_HISTORY: {
    cardComponentLoader: () => import( /* webpackChunkName: "ActivityHistoryCard" */'card-flywheel-activity-history-lib/ActivityHistoryCard'),
    lazyLoadedTranslations: activityHistoryCardTranslations,
    dataResolver: flywheelActivityHistoryDataResolver
  },
  FLYWHEEL_COMPANY_OVERVIEW: {
    cardComponentLoader: () => import( /* webpackChunkName: "CompanyOverviewCard" */'card-flywheel-company-overview-lib/CompanyOverviewCard'),
    lazyLoadedTranslations: flywheelCompanyOverviewCardTranslations
  },
  FLYWHEEL_DOMAIN_REVIEW_HISTORY: {
    cardComponentLoader: () => import( /* webpackChunkName: "DomainReviewHistoryCard" */'card-flywheel-domain-review-history-lib/DomainReviewHistoryCard'),
    lazyLoadedTranslations: domainReviewHistoryCardTranslations,
    dataResolver: flywheelDomainReviewHistoryDataResolver
  },
  FLYWHEEL_HIGH_INTENT_ASSOCIATED_CONTACTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "AssociatedContactsCard" */'card-flywheel-high-intent-associated-contacts-lib/AssociatedContactsCard'),
    lazyLoadedTranslations: flywheelHighIntentAssociatedContactsCardTranslations
  },
  FLYWHEEL_GROWTH_PLANS: {
    cardComponentLoader: () => import( /* webpackChunkName: "FlywheelGrowthPlansCrmCard" */'flywheel-growth-plans-crm-card/FlywheelGrowthPlansCrmCard'),
    lazyLoadedTranslations: flywheelGrowthPlansCardTranslations,
    dataResolver: flywheelGrowthPlansDataResolver
  },
  GUEST_ACCESS_MANAGEMENT: {
    cardComponentLoader: () => import( /* webpackChunkName: "GuestAccessManagementCard" */'card-guest-access-management-lib/components/GuestAccessManagementCard'),
    lazyLoadedTranslations: guestAccessManagementCardTranslations
  },
  GUIDED_ACTIONS: {
    cardComponentLoader: () => import( /* webpackChunkName: "GuidedActionsCard" */'guided-actions-card/GuidedActionsCard'),
    lazyLoadedTranslations: guidedActionsCardTranslations
  },
  GUIDED_EXECUTION_ACTIVITIES: {
    cardComponentLoader: () => import( /* webpackChunkName: "GuidedExecutionActivitiesCard" */'card-guided-execution-activities'),
    lazyLoadedTranslations: guidedExecutionActivitiesCardTranslations
  },
  GUIDED_SELLING_STAGE_TRACKER: {
    cardComponentLoader: () => import( /* webpackChunkName: "GuidedSellingStageTrackerCard" */'guided-selling-stage-tracker-card/components/GuidedSellingStageTrackerCard'),
    lazyLoadedTranslations: guidedSellingStageTrackerCardTranslations,
    getLoadingComponentProps: () => {
      return [{
        type: SPINNER,
        minHeight: 140
      }];
    }
  },
  HELP_DESK_TICKET_SUMMARY: {
    cardComponentLoader: () => import('card-ticket-summary-lib/TicketSummaryCard'),
    lazyLoadedTranslations: ticketSummaryCardTranslations
  },
  HELP_DESK_KNOWLEDGE_BASE: {
    cardComponentLoader: () => import('card-knowledge-base-lib/KnowledgeBaseCard'),
    lazyLoadedTranslations: knowledgeBaseCardTranslations
  },
  INTELLIGENCE_CONTENT: {
    cardComponentLoader: () => import( /* webpackChunkName: "IntelligenceOverviewCard" */'intelligence-overview-card'),
    lazyLoadedTranslations: intelligenceOverviewTranslations
  },
  LEAD_QUALIFICATION: {
    cardComponentLoader: () => import( /* webpackChunkName: "LeadQualificationCard" */'card-lead-qualification-lib/LeadQualificationCard'),
    lazyLoadedTranslations: leadQualificationCardTranslations
  },
  LEAD_INSIGHTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "LeadInsightsCard" */'card-lead-insights'),
    lazyLoadedTranslations: leadInsightsCardTranslations
  },
  LEGACY_SIDEBAR_CARD: {
    CardComponent: LegacySidebarCard,
    lazyLoadedTranslations: legacySidebarCardTranslations,
    getLoadingComponentProps: getLoadingComponentPropsForLegacySidebarCard
  },
  MARKETING_LEAD_SCORES: {
    cardComponentLoader: () => import( /* webpackChunkName: "LeadScoresCard" */'lead-scores-card/LeadScoresCard'),
    lazyLoadedTranslations: leadScoresCardTranslations
  },
  MARKETING_EVENT_PARTICIPATION: {
    cardComponentLoader: () => import( /* webpackChunkName: "MarketingEventAttendanceCard" */'marketing-event-attendance-cards-ui/MarketingEventAttendanceCard'),
    lazyLoadedTranslations: marketingEventAttendanceCardTranslations
  },
  OBJECT_HIGHLIGHT: {
    cardComponentLoader: () => import( /* webpackChunkName: "ObjectHighlightCard" */'card-object-highlight-lib/ObjectHighlightCard'),
    lazyLoadedTranslations: objectHighlightCardTranslations
  },
  OTHER_TICKETS: {
    cardComponentLoader: () => import('card-other-tickets-lib/other-tickets/OtherTicketsCard'),
    lazyLoadedTranslations: otherTicketsCardTranslations
  },
  PAYMENT_SCHEDULE: {
    cardComponentLoader: () => import( /* webpackChunkName: "payment-schedule-card-lib" */'payment-schedule-card-lib/public/PaymentScheduleCard'),
    lazyLoadedTranslations: paymentScheduleCardTranslations
  },
  PINNED_ACTIVITY: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmPinnedActivityCard" */'crm-events-viz-cards/crmPinnedActivityCard/CrmPinnedActivityCard'),
    lazyLoadedTranslations: crmEventsVizTimelineCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: EVENTS_VIZ_TIMELINE_ENTRY_HEIGHT
    }]
  },
  PIPELINE_APPROVALS: {
    cardComponentLoader: () => import( /* webpackChunkName: "crm-pipeline-approvals-lib" */'crm-pipeline-approvals-lib').then(mod => mod.PipelineApprovalsCard),
    lazyLoadedTranslations: pipelineApprovalsCardTranslations
  },
  PROCESS_GUIDE_LIST: {
    cardComponentLoader: () => import( /* webpackChunkName: "ProcessGuideListCard" */'process-guide-cards/cards/ProcessGuideListCard'),
    lazyLoadedTranslations: processGuideCardTranslations
  },
  PRODUCT_HISTORY: {
    cardComponentLoader: () => import( /* webpackChunkName: "purchase-history-lib" */'purchase-history-lib').then(mod => mod.ProductHistoryCard),
    lazyLoadedTranslations: purchaseHistoryCardsTranslations
  },
  PROPERTIES_LIST: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmPropertiesListCard" */'crm-properties-list/CrmPropertiesListCard'),
    lazyLoadedTranslations: crmPropertiesListTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight:
        // Propeties List card uses up to 4 columns
        Math.ceil(cardData.configuration.propertyNames.length / 4) * 50
      }];
    }
  },
  PROPERTIES_V3: {
    cardComponentLoader: () => import( /* webpackChunkName: "PropertiesV3" */'card-properties-lib/sdk'),
    lazyLoadedTranslations: aboutThisRecordCardTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: TEXT_LIST,
        count: cardData.configuration.propertyNames.length
      }];
    }
  },
  PROPERTY_HISTORY: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmPropertiesHistoryCard" */'crm-property-history/CrmPropertyHistoryCard'),
    lazyLoadedTranslations: crmPropertyHistoryTranslations
  },
  PROSPECTING_AGENT: {
    cardComponentLoader: () => import( /* webpackChunkName: "ProspectingAgentCrmCard" */'prospecting-agent-crm-card/ProspectingAgentCrmCard'),
    lazyLoadedTranslations: prospectingAgentCardTranslations,
    dataResolver: prospectingAgentCardDataResolver
  },
  PROSPECTING_RESEARCH_AGENT: {
    cardComponentLoader: () => import( /* webpackChunkName: "ProspectingResearchAgentCard" */'card-prospecting-research-agent/ProspectingResearchAgentCard'),
    lazyLoadedTranslations: prospectingResearchAgentCardTranslations
  },
  PURCHASE_DATA_WELL: {
    cardComponentLoader: () => import( /* webpackChunkName: "purchase-history-lib" */'purchase-history-lib').then(mod => mod.PurchaseDataWell),
    lazyLoadedTranslations: purchaseHistoryCardsTranslations
  },
  RELATIVE_TIMELINE: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmRelativeTimelineCard" */'crm-relative-timeline/CrmRelativeTimelineCard'),
    lazyLoadedTranslations: crmRelativeTimelineTranslations
  },
  SIMPLE_DEADLINE: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmSimpleDeadlineCard" */'crm-simple-deadline/CrmSimpleDeadlineCard'),
    lazyLoadedTranslations: crmSimpleDeadlineTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight: cardData.configuration.showProperties ? 140 : 85
      }];
    }
  },
  STAGE_TRACKER: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmStageTrackerCard" */'crm-stage-tracker/CrmStageTrackerCard'),
    lazyLoadedTranslations: crmStageTrackerTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight: cardData.configuration.showProperties ? 140 : 85
      }];
    }
  },
  STATISTICS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmStatisticsCard" */'crm-statistics/CrmStatisticsCard'),
    lazyLoadedTranslations: crmStatisticsTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight:
        // Rough estimate - we don't know how many statistics will fit on one row
        Math.ceil(cardData.configuration.statistics.length / 5) * 60
      }];
    }
  },
  CONTRACT_BILLING_INFO: {
    cardComponentLoader: () => import( /* webpackChunkName: "ContractBillingInfoCard" */'commerce-contract-lib/public/ContractBillingInfoCard'),
    lazyLoadedTranslations: contractCardTranslations
  },
  CONTRACT_CHANGES: {
    cardComponentLoader: () => import( /* webpackChunkName: "ContractChanges" */'commerce-contract-lib/public/ContractChanges'),
    lazyLoadedTranslations: contractCardTranslations
  },
  CONTRACT_DETAILS: {
    cardComponentLoader: () => import( /* webpackChunkName: "ContractDetailsCard" */'commerce-contract-lib/public/ContractDetailsCard'),
    lazyLoadedTranslations: contractCardTranslations
  },
  CONTRACT_LINE_ITEMS: {
    cardComponentLoader: () => import( /* webpackChunkName: "ContractLineItemsCard" */'commerce-contract-lib/public/ContractLineItemsCard'),
    lazyLoadedTranslations: contractCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 120
    }]
  },
  BILLING_SCHEDULE: {
    cardComponentLoader: () => import( /* webpackChunkName: "BillingScheduleCard" */'commerce-billing-engine-lib/public/BillingScheduleCard'),
    lazyLoadedTranslations: billingScheduleCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: 120
    }]
  },
  SUBSCRIPTION_BILLING_INFO: {
    cardComponentLoader: () => import( /* webpackChunkName: "SubscriptionSidebarBillingInfoCard" */'commerce-subscription-cards-lib/cards/billing-info').then(mod => mod.SubscriptionSidebarBillingInfoCard),
    lazyLoadedTranslations: subscriptionSidebarCardTranslations
  },
  SUBSCRIPTION_PAYMENTS_TIMELINE: {
    cardComponentLoader: () => import( /* webpackChunkName: "SubscriptionSidebarTimelineCard" */'commerce-subscription-cards-lib/cards/timeline').then(mod => mod.SubscriptionSidebarTimelineCard),
    lazyLoadedTranslations: subscriptionSidebarCardTranslations
  },
  COMMERCE_PAYMENT_DISPUTE_CARD: {
    cardComponentLoader: () => import( /* webpackChunkName: "CommercePaymentDisputeCard" */'commerce-payment-dispute-card/CommercePaymentDisputeCard'),
    lazyLoadedTranslations: commercePaymentDisputeCardTranslations,
    dataResolver: commercePaymentDisputeDataResolver,
    getLoadingComponentProps: () => {
      return [{
        type: TEXT_LIST,
        count: 4
      }];
    }
  },
  TARGET_ACCOUNT_SIGNALS: {
    cardComponentLoader: () => import( /* webpackChunkName: "TargetAccountSignalsCard" */'card-target-account-signals/TargetAccountSignalsCard'),
    lazyLoadedTranslations: targetAccountSignalsCardTranslations
  },
  TASKS_TIMELINE: {
    cardComponentLoader: () => import('card-tasks-timeline-lib/TasksTimelineCard'),
    lazyLoadedTranslations: tasksTimelineCardTranslations
  },
  UPCOMING_ACTIVITIES: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmUpcomingActivitiesCard" */'crm-events-viz-cards/crmUpcomingActivitiesCard/CrmUpcomingActivitiesCard'),
    lazyLoadedTranslations: crmEventsVizTimelineCardTranslations,
    loadingComponentProps: [{
      type: SPINNER,
      minHeight: EVENTS_VIZ_TIMELINE_ENTRY_HEIGHT
    }]
  },
  NATIVE_INVOICES_HISTORY: {
    cardComponentLoader: () => import( /* webpackChunkName: "invoices-history-card-lib" */'invoices-history-card-lib').then(mod => mod.InvoicesHistoryCard),
    lazyLoadedTranslations: invoicesHistoryCardTranslations
  },
  PARTNER_AI_SUMMARY: {
    cardComponentLoader: () => import( /* webpackChunkName: "PartnerAiSummaryCard" */'partner-ai-summary-crm-card/PartnerAiSummaryCrmCard'),
    lazyLoadedTranslations: partnerAiSummaryCardTranslations,
    dataResolver: partnerAiSummaryCardDataResolver
  },
  PARTNER_CLIENT_UNIFIED_USAGE_SCORE: {
    cardComponentLoader: () => import( /* webpackChunkName: "UnifiedUsageScoreCard" */'card-partner-client-unified-usage-score-lib/UnifiedUsageScoreCard'),
    lazyLoadedTranslations: unifiedUsageScoreCardTranslations
  },
  PARTNER_CLIENT_PRODUCT_USAGE_OUTCOMES: {
    cardComponentLoader: () => import( /* webpackChunkName: "ProductUsageOutcomesCard" */'card-partner-client-portal-usage-outcomes-lib/ProductUsageOutcomesCard'),
    lazyLoadedTranslations: portalUsageOutcomesCardTranslations
  },
  GUIDED_SELLING_DEAL_SUMMARY: {
    cardComponentLoader: () => import( /* webpackChunkName: "GuidedSellingDealSummaryCard" */'deal-summary-components/GuidedSellingDealSummaryCard'),
    lazyLoadedTranslations: guidedSellingDealSummaryTranslations
  },
  QUICK_ACTIONS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmQuickActionsCard" */'crm-quick-actions/CrmQuickActionsCard'),
    lazyLoadedTranslations: crmActionsTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: SPINNER,
        minHeight: Math.ceil(cardData.configuration.actions.length / 3) * 60
      }];
    }
  },
  WORKFLOWS_INVOKER: {
    cardComponentLoader: () => import( /* webpackChunkName: "WorkflowsInvokerCard" */'automation-ui-crm-card-workflows-invoker/WorkflowsInvokerCard'),
    lazyLoadedTranslations: workflowsInvokerCardTranslations
  },
  SHOPIFY_OVERVIEW: {
    cardComponentLoader: () => import( /* webpackChunkName: "CustomerOverviewCard" */'customer-overview-card-lib/CustomerOverviewCard'),
    lazyLoadedTranslations: shopifyOverviewCardTranslations
  },
  GOOGLE_DRIVE_ATTACHMENTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "GoogleDriveAttachmentsCard" */'ui-google-drive-attachments/GoogleDriveAttachmentsCard'),
    lazyLoadedTranslations: googleDriveAttachmentsCardTranslations
  },
  GOOGLE_DRIVE_INSIGHTS: {
    cardComponentLoader: () => import( /* webpackChunkName: "GoogleDriveInsightsCard" */'ui-google-drive-insights/GoogleDriveInsightsCard'),
    lazyLoadedTranslations: googleDriveInsightsCardTranslations
  },
  PRODUCT_PRICING_INFO: {
    cardComponentLoader: () => import( /* webpackChunkName: "products-cards-lib" */'products-cards-lib').then(mod => mod.ProductPricingInfoCard),
    lazyLoadedTranslations: productPricingInfoCardTranslations
  },
  PRODUCT_BUNDLE_ABOUT: {
    cardComponentLoader: () => import( /* webpackChunkName: "bundle-about-card" */'bundle-about-card/BundleAboutCard'),
    lazyLoadedTranslations: productBundleAboutCardTranslations,
    dataResolver: productBundleAboutCardDataResolver
  },
  PRODUCT_BUNDLE_ITEMS: {
    cardComponentLoader: () => import( /* webpackChunkName: "bundle-items-card" */'bundle-items-card/BundleItemsCard'),
    lazyLoadedTranslations: productBundleItemsCardTranslations,
    dataResolver: productBundleItemsCardDataResolver
  },
  CLV_REPORT: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmCLVReportCard" */'crm-clv-report/js/CrmCLVReportCard'),
    lazyLoadedTranslations: clvReportCardTranslations
  },
  CSAT: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmCsatCard" */'crm-csat/CrmCsatCard'),
    lazyLoadedTranslations: csatCardTranslations
  },
  NPS: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmNpsCard" */'crm-nps/CrmNpsCard'),
    lazyLoadedTranslations: npsCardTranslations
  },
  CUSTOM_EVENT: {
    cardComponentLoader: () => import( /* webpackChunkName: "CustomEventCard" */'custom-events-card-lib/CustomEventCard'),
    lazyLoadedTranslations: customEventCardTranslations
  },
  ATTRIBUTION_REPORT: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmAttributionReportCard" */'crm-attribution-report/CrmAttributionReportCard'),
    lazyLoadedTranslations: crmAttributionReportTranslations
  },
  RECORD_TIMELINE: {
    cardComponentLoader: () => import( /* webpackChunkName: "CrmRecordTimelineCard" */'crm-events-viz-cards/crmRecordTimelineCard/CrmRecordTimelineCard'),
    loadingComponentProps: [{
      type: CHICLET_LIST,
      numberOfSkeletons: 6,
      numberOfProperties: 4
    }],
    lazyLoadedTranslations: crmRecordTimelineCardTranslations
  },
  SNAPSHOT: {
    cardComponentLoader: () => import( /* webpackChunkName: "PropertiesV3" */'card-properties-lib/sdk'),
    lazyLoadedTranslations: aboutThisRecordCardTranslations,
    getLoadingComponentProps: cardData => {
      return [{
        type: TEXT_LIST,
        count: cardData.configuration.propertyNames.length
      }];
    }
  },
  BUYING_GROUP: {
    cardComponentLoader: () => import( /* webpackChunkName: "BuyingGroupCard" */'buying-group-card/BuyingGroupCard'),
    lazyLoadedTranslations: buyingGroupCardTranslations,
    dataResolver: buyingGroupCardDataResolver
  }
};